// Legacy blog redirects: every URL shape of the old WordPress blog (/blog/…, also /Blog/…: the
// router ignores case) goes to its place in /news, which now holds those posts.
//   /blog/2011/08/25/<slug>/, /blog/<slug>/, /blog/?p=1 → /news/… (looked up by slug or id:
//     fullstack /api/v1/news/legacy-blog; not worked out from the URL's date, which WordPress
//     wrote in local time while /news uses UTC dates, so the two can differ by a day)
//   /blog/2011/08/            → /news/2011#month-2011-08
//   /blog/2011/               → /news/2011
//   /blog, tag/category/author/page/feed/comments pages → /news
// Also the earlier /news addresses, /news/<slug> (e.g. /news/2011-08-24-slides-…, which the
// lookups above return), → their current form /news/2011/08-24.
// Images (/blog/wp-content/…) never reach the router: Frontend vercel.json (and vue.config.js in
// dev) sends them to the saved copies in fullstack/public/images/blog.

import {fetchNewsYear, getNewsItemPath} from "@/composables/useNews";
import {getFullstackUrl} from "@/composables/useFullstackUrl";

const FULLSTACK = getFullstackUrl();
const EMPTY_PAGE = {render: () => null}; // shown never: each route redirects before rendering

function getYearPath(year) {
  return `/news/${year}`;
}

async function fetchNewsPath(query) {
  try {
    const response = await fetch(`${FULLSTACK}/api/v1/news/legacy-blog?${query}`);
    if (!response.ok) return "/news";
    return (await response.json()).path || "/news";
  } catch {
    return "/news";
  }
}

const lookUpSlug = (to) => fetchNewsPath(`slug=${encodeURIComponent(to.params.slug)}`);

// /news/<slug> → /news/2011/08-24 (or that year's page, if the item isn't found)
async function resolveNewsSlug(to) {
  const {slug} = to.params;
  const items = await fetchNewsYear(slug.slice(0, 4));
  const item = items.find((entry) => entry.slug === slug);
  return item ? getNewsItemPath(item, items) : getYearPath(slug.slice(0, 4));
}

// /blog or /blog/?p=<id>
function lookUpBlogRoot(to) {
  if (!to.query.p) return "/news";
  return fetchNewsPath(`id=${encodeURIComponent(to.query.p)}`);
}

export const legacyBlogRedirects = [
  {
    path: "/blog/:year(\\d{4})/:month(\\d{2})/:day(\\d{2})/:slug/:rest(.*)*",
    component: EMPTY_PAGE,
    beforeEnter: lookUpSlug
  },
  {
    path: "/blog/:year(\\d{4})/:month(\\d{2})/:rest(.*)*",
    redirect: ({params: {year, month}}) => ({
      path: getYearPath(year), hash: `#month-${year}-${month}`
    })
  },
  {
    path: "/blog/:year(\\d{4})/:rest(.*)*",
    redirect: ({params: {year}}) => getYearPath(year)
  },
  {
    path: "/blog/:section(tag|category|author|page|feed|comments)/:rest(.*)*",
    redirect: "/news"
  },
  {path: "/blog/:slug/:rest(.*)*", component: EMPTY_PAGE, beforeEnter: lookUpSlug},
  {path: "/blog", component: EMPTY_PAGE, beforeEnter: lookUpBlogRoot},
  {path: "/news/:slug(\\d{4}-\\d{2}-\\d{2}.*)", component: EMPTY_PAGE, beforeEnter: resolveNewsSlug}
];
